
export namespace Area {
    export const MobileNavigation: string = "MobileNavigation";
}

export namespace Feature {
    export const SwitchToMobile: string = "SwitchToMobile";
    export const HamburgerMenuClick: string = "HamburgerMenuClick";
    export const SwitchToFullSite: string = "SwitchToFullSite";
    export const UserFeedbackClick: string = "UserFeedbackClick";
    export const NavigationItemToggleExpand: string = "NavigationItemToggleExpand";
    export const NavigationItemClick: string = "NavigationItemClick";
    export const AccountNameClick: string = "AccountNameClick";
    export const AccountIconClick: string = "AccountIconClick";
}

export class UrlParameterKey {
    public static TrackingData = "tracking_data";
}
